import { Fill, Worksheet } from "exceljs";
import i18n from "i18n";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { roundBy } from "utils/DecimalUtils";
import { borderThinStyle, fillLightGray, fontNormal } from "./ReportStyles";

const ABC_COLOR = [
  { pMin: 0, pMax: 80, c: "ffff4500", toolbar: "Curva A - De 0% a 80%" },
  { pMin: 80, pMax: 95, c: "ffff8c00", toolbar: "Curva B - De 80,01% a 95%" },
  { pMin: 95, pMax: 101, c: "ffc0d147", toolbar: "Curva C - De 95,01% a 100%" },
];

const getDataFormating = (worksheet: Worksheet) => {
  worksheet = setColumnHeader(worksheet);

  let formatedData: any = [];
  let takeOffModelMap: any = TakeOffStore.takeOffModelMap;
  let indexSelected = TakeOffStore.takeOffFormatedList.findIndex(
    (i) => i.id == takeOffModelMap.id
  );

  let list = TakeOffStore.takeOffFormatedList[indexSelected]
    ? TakeOffStore.takeOffFormatedList[indexSelected].data
    : new Array();

  for (let i = 0; i < list.length; i++) {
    let e = list[i];
    formatedData.push({
      description: e.description ? e.description : "",
      resultQuantity: e.resultQuantity
        ? roundBy(e.resultQuantity, WBSPropertiesStore.getRules(2))
        : "",
      unit: e.unit ? e.unit : "",
    });
  }

  for (let i = 0; i < formatedData.length; i++) {
    let color = "ff00ff00";
    let percentage = formatedData[i]["cumulative_percentage"] * 100;
    let tmpColor = ABC_COLOR.filter(
      (abc) => percentage > abc.pMin && percentage <= abc.pMax
    )[0];
    if (tmpColor != undefined) {
      color = tmpColor.c;
    }
    if (formatedData[i]["description"] == undefined) continue;
    let fillPercentage: Fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: {
        argb: color,
      },
    };

    worksheet.getCell("L" + (i + 13)).fill = fillPercentage;

    worksheet.getCell("A" + (i + 13)).value = formatedData[i]["description"];
    worksheet.getCell("F" + (i + 13)).value = formatedData[i]["resultQuantity"];
    worksheet.getCell("I" + (i + 13)).value = formatedData[i]["unit"];

    worksheet.mergeCells(
      "A" + (i + 13).toString() + ":E" + (i + 13).toString()
    );
    worksheet.mergeCells(
      "F" + (i + 13).toString() + ":H" + (i + 13).toString()
    );
    worksheet.mergeCells(
      "I" + (i + 13).toString() + ":L" + (i + 13).toString()
    );

    let array = ["A", "F", "I"];
    for (let j = 0; j < array.length; j++) {
      worksheet.getCell(array[j] + (i + 13)).font = fontNormal;
      worksheet.getCell(array[j] + (i + 13)).border = borderThinStyle;
      worksheet.getCell(array[j] + (i + 13)).fill = fillLightGray;
      worksheet.getCell(array[j] + (i + 13)).alignment = { vertical: "middle" };
    }
  }

  return worksheet;
};

const setColumnHeader = (worksheet: Worksheet) => {
  worksheet.getCell("A12").value = i18n.resources.description;
  worksheet.getCell("F12").value = i18n.resources.quantity;
  worksheet.getCell("I12").value = i18n.resources.unity;
  worksheet.mergeCells("A12:E12");
  worksheet.mergeCells("F12:H12");
  worksheet.mergeCells("I12:L12");
  return worksheet;
};

export default getDataFormating;



// WEBPACK FOOTER //
// ./src/modules/costPlan/assets/excelReports/formatingCustom.ts